var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "btn-group btn-group-sm",
      attrs: { role: "group", "aria-label": "Paragraph format" },
    },
    [
      _c("div", { staticClass: "dropdown" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-sm dropdown-toggle",
            class: { "btn-light": !_setup.isDarkMode },
            attrs: {
              type: "button",
              id: "paragraphFormatDropdown",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false",
            },
          },
          [
            _vm.editor.isActive("heading", { level: 1 })
              ? _c("span", [_vm._v("Heading 1")])
              : _vm.editor.isActive("heading", { level: 2 })
              ? _c("span", [_vm._v("Heading 2")])
              : _vm.editor.isActive("heading", { level: 3 })
              ? _c("span", [_vm._v("Heading 3")])
              : _vm.editor.isActive("heading", { level: 4 })
              ? _c("span", [_vm._v("Heading 4")])
              : _vm.editor.isActive("heading", { level: 5 })
              ? _c("span", [_vm._v("Heading 5")])
              : _vm.editor.isActive("heading", { level: 6 })
              ? _c("span", [_vm._v("Heading 6")])
              : _vm.editor.isActive("paragraph")
              ? _c("span", [_vm._v("Paragraph")])
              : _vm.editor.isActive("codeBlock")
              ? _c("span", [_vm._v("Code block")])
              : _c("span", [_vm._v("Format")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass: "dropdown-menu",
            attrs: { "aria-labelledby": "paragraphFormatDropdown" },
          },
          [
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  class: { active: _vm.editor.isActive("paragraph") },
                  on: {
                    click: function ($event) {
                      return _vm.editor.commands.setParagraph()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "bi bi-text-paragraph me-1" }),
                  _vm._v(" "),
                  _c("small", [_vm._v("Paragraph")]),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm._l(6, function (level) {
              return _c("li", { key: level }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "dropdown-item d-flex justify-content-between align-items-center",
                    class: {
                      active: _vm.editor.isActive("heading", { level }),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.editor.commands.toggleHeading({ level })
                      },
                    },
                  },
                  [
                    _c("i", { class: `bi bi-type-h${level} me-1` }),
                    _vm._v(" "),
                    _c("small", [_vm._v("Heading")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-muted ms-5 small" }, [
                      _vm._v(
                        _vm._s(
                          _setup.modKey + " " + _setup.optKey + " " + level
                        )
                      ),
                    ]),
                  ]
                ),
              ])
            }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("li", [
              _c(
                "a",
                {
                  staticClass:
                    "dropdown-item d-flex justify-content-between align-items-center",
                  class: { active: _vm.editor.isActive("codeBlock") },
                  on: {
                    click: function ($event) {
                      return _vm.editor.commands.toggleCodeBlock()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "bi bi-file-earmark-code me-1" }),
                  _vm._v(" "),
                  _c("small", [_vm._v("Code block")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-muted ms-5 small" }, [
                    _vm._v("```"),
                  ]),
                ]
              ),
            ]),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("li", [_c("hr", { staticClass: "dropdown-divider" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }